import React from 'react'
import ShareButton from '../../components/shared/SocialShare/ShareButton'
import Product from 'api/models/Product'

interface Props {
  product: Product,
  storeId: string,
  children: React.ReactNode
}

export default function ProductShareButton({ product, storeId, children }: Props) {
  return (
    <ShareButton
      itemUrl={product.getOwnUrl(storeId)}
      itemName={product.getName()}
      description={product.getDescription()}
      itemId={product.getId()}
      socialPhotos={product.getImages()}
      vertical
    >
      {children}
    </ShareButton>
  )
}